import { useBreakpointValue } from "@gluestack-style/react";
import useToast from "@repo/core/components/core/Toast";
import { useGeneratePdf } from "@repo/core/hooks/useGeneratePdf";
import { useNavigation } from "@repo/core/hooks/useNavigation";
import { useRouteParams } from "@repo/core/hooks/useRouteParams";
import { ROUTES } from "@repo/core/routes";
import { ProofOfTransaction } from "@repo/core/services/entities/Transactions";
import { apiInstance } from "@repo/core/services/instances/api";
import { TerminalResource } from "@repo/core/services/resources/terminal";
import { getDDDAndNumberOfPhoneNumber } from "@repo/core/utils/string.utils";

const terminalResources = new TerminalResource(apiInstance)

export const SecondCopyOfReceiptController = () => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const { viewRef, handleCaptureAndGeneratePDF, isLoading } = useGeneratePdf();
  const { back, replace } = useNavigation();
  const toast = useToast()
  const state = useRouteParams();

  const data: ProofOfTransaction = state;

  const handleGoToSales = () => {
    replace(ROUTES.sales);
  };

  const handleSendSMS = async (phoneNumber: string) => {
    try {
      const { phoneDDD, phone } = getDDDAndNumberOfPhoneNumber(phoneNumber);

      if (!phoneDDD || !phone) {
        toast.error("Confira o número do celular e tente novamente!")
        return;
      }

      await terminalResources.sendTransactionReceiptOnSMS(data.nsuProcessadora, phoneDDD, phone)

      toast.success("Comprovante enviado")
    } catch (e) {
      toast.error("Não foi possível enviar comprovante, tente novamente!")
    }
  }

  return {
    back,
    data,
    isMobile,
    handleGoToSales,
    viewRef,
    handleSendSMS,
    handleCaptureAndGeneratePDF,
    isLoading
  };
};
